import { decrypt, readMessage } from "openpgp";

import encryptLeak from "./encryption.js";
import { setProgressCallback, upload } from "./upload.js";

const uploadError = document.getElementById("upload-error");
const pubkey = document.getElementById("pubkey").value;
const maxMessageSize = parseInt(document.getElementById("maxmessage").value);
const progress = document.getElementById("progress");
const uploadSuccess = document.getElementById("upload-success");
const answerError = document.getElementById("answer-error");
const questionError = document.getElementById("question-error");
const messageBtn = document.getElementById("getMesssageBtn");
const answerBtn = document.getElementById("sendAnswerBtn");
const uploadSuccessWithContactKey = document.getElementById(
  "upload-success-with-contact-key"
);

messageBtn.addEventListener("click", handleGetMessage);
answerError.addEventListener("click", handleAnswerErrorClick);
answerBtn.addEventListener("click", handleFormSubmitReply);

function handleAnswerErrorClick() {
  answerError.className = "notice";
}

async function handleGetMessage() {

  const key = document.getElementById("contactInfoKey").value;
  try {
    const encryptedMessage = await fetch("/meddelande", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ contactInfoKey: key.slice(15) }),
    });
    if (encryptedMessage.ok === false) {
      throw new Error("Kunde ej hitta meddelandet.");
    }
    const message = await encryptedMessage.text();
    const decryptedMessage = await decryptMessage(message, key.slice(0, 15));
    const messageDiv = document.getElementById("message");
    messageDiv.innerText = decryptedMessage.data;
    messageDiv.style.display = "block";
    document.getElementById("form-message").style.display = "none";
    document.getElementById("answer-header").innerText = "Ditt meddelande";
    document.getElementById("reply-form").classList.remove("hidden");
  } catch (e) {
    answerError.className = "notice visible";
  }
}

async function decryptMessage(base64Message, key) {
  const armoredMessage = atob(base64Message);
  const pgpMessage = await readMessage({ armoredMessage });
  return await decrypt({
    message: pgpMessage,
    passwords: [ key ],
    format: "utf8",
  });
}

function randomKey(length = 15) {
  const alphabet = "abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNP23456789!#%&=?";
  return Array.from({ length }, () => randChar(alphabet)).join("");
}

function randChar(alphabet) {
  const randomBuffer = new Uint32Array(1);
  window.crypto.getRandomValues(randomBuffer);
  const randomNumber = randomBuffer[0] / (0xffffffff + 1);
  const index = Math.floor(randomNumber * alphabet.length);
  return alphabet.charAt(index);
}

function handleFormSubmitReply(event) {

  event.preventDefault();
  const replyInput = document.getElementById("reply-description");
  const description = `SVAR: ${replyInput.value}`;
  const answer = "noCaptcha";
  const expectedAnswer = null;

  const envelope = {
    encryptedOnClient: true,
    description,
    contactInfoKey: randomKey(),
    contactInfoFileName: randomKey(),
    filenames: [],
  };

  progress.style.display = "block";

  setProgressCallback(handleUploadProgress);

  encryptLeak(pubkey, JSON.stringify(envelope), false)
    .then((envelopeData) => {
      const filesData = [];
      const answerFlow = true;

      return upload(
        envelopeData,
        filesData,
        answer,
        expectedAnswer,
        maxMessageSize,
        answerFlow
      );
    })
    .then(() => {

      if (envelope.contactInfoKey !== null) {
        const contactKey = `${envelope.contactInfoKey}${envelope.contactInfoFileName}`;
        uploadSuccessWithContactKey.querySelector(".key").textContent = contactKey;
        uploadSuccessWithContactKey.className = "notice visible";
      } else {
        uploadSuccess.className = "notice visible";
      }
      document.body.className = "locked";
    })
    .then(() => {
      setProgressCallback(null);
    })
    .catch((err) => {

      progress.removeAttribute("style");
      if (err.message === "failquestion") {
        questionError.querySelector(".qerror").textContent = "Du har angett fel text.";

      } else {

        uploadError.className = "notice visible";
      }
    });
}

function handleUploadProgress(current, total) {
  const progressCount = parseInt((current / total) * 100, 10);
  progress.querySelector(".count").textContent = `${progressCount}%`;
  if (current === total) {
    progress.removeAttribute("style");
  }
}
